module.exports = __webpack_public_path__ + "img/logo_dafuwan.b8857c0e.jpg";